"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_workloads_1 = require("owa-workloads");
var owa_options_general_1 = require("owa-options-general");
var owa_options_mail_1 = require("owa-options-mail");
var owa_options_calendar_1 = require("owa-options-calendar");
function getDefaultCategory() {
    switch (owa_workloads_1.getOwaWorkload()) {
        case 1 /* Mail */:
        case 16 /* MailMini */:
            return owa_options_mail_1.MailOptions.key;
        case 2 /* Calendar */:
            return owa_options_calendar_1.CalendarOptions.key;
        default:
            return owa_options_general_1.GeneralOptions.key;
    }
}
exports.default = getDefaultCategory;
//# sourceMappingURL=getDefaultCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-options-store/lib/utils/getDefaultCategory.js
// module id = 5275
// module chunks = 2